import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#2B3035',
      light: '#07B082',
      text: '#ffffff'
    },
    secondary: {
      main: '#C61E1F',
      text: '#ffffff'
    },
    background: {
      paper: '#E8E8ED'
    }
  },
  typography: {
    fontFamily: 'Oswald, Arial, sans-serif',
    fontSize: 12,
    h1: {
      fontFamily: 'Oswald, Arial, sans-serif',
      fontSize: 40
    },
    h2: {
      fontFamily: 'Oswald, Arial, sans-serif',
      fontSize: 32
    },
    h3: {
      fontFamily: 'Oswald, Arial, sans-serif',
      fontSize: 24
    },
    h4: {
      fontFamily: 'Oswald, Arial, sans-serif',
      fontSize: 20
    },
    h5: {
      fontFamily: 'Oswald, Arial, sans-serif',
      fontSize: 16
    },
    h6: {
      fontFamily: 'Oswald, Arial, sans-serif',
      fontSize: 14
    }
  },
  components: {
    // the default 11px is a label, not a sentence, and every tooltip here explains something
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontFamily: '"Source Sans Pro", Arial, sans-serif',
          fontSize: '13.5px',
          fontWeight: 400,
          lineHeight: 1.45,
          padding: '9px 13px',
          maxWidth: 340,
          backgroundColor: 'rgba(43, 48, 53, 0.96)'
        }
      }
    }
  }
})

export default theme